// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import setNestedValueInObject from 'helpers/setNestedValueInObject'

// Since redux needs a new object to trigger state update,
// we need to create a new state object which takes all the values
// that the former state object had and then set the updated nested value.

const setNestedInReduxState = (obj, path, value) => (
  setNestedValueInObject(
    { ...obj },
    path,
    value,
  )
)

export default setNestedInReduxState
